import store from '@/state/store'

let isRefreshing = false;
let refreshSubscribers = [];

export default async function BadResponseInterceptor(error)  {
  console.log(store);
  const { config, response: { status } } = error;
  const originalRequest = config;

  if (status === 498) {

    if (!isRefreshing) {
      isRefreshing = true;
      API.post('/auth/refresh', {refreshToken: state.currentUser.refreshToken})
              .then(newToken => {
                isRefreshing = false;
                onRefreshed(newToken);
      });
    }

    const retryOrigReq = new Promise((resolve, reject) => {
        subscribeTokenRefresh(token => {
          // replace the expired token and retry
          originalRequest.headers['Authorization'] = 'Bearer ' + token;
          resolve(axios(originalRequest));
        });
      });
      return retryOrigReq;

  } else {
    return Promise.reject(error);
  }
}



// WEBPACK FOOTER //
// ./src/lib/api/APIRefreshTokenInterceptor.js